module.exports = __webpack_public_path__ + "static/media/thinking.65143d06.png";